import {
  ContextActionCommand,
  GetContextActionsOptions,
} from '@wix/public-editor-platform-interfaces';
import { BaseSDKShape } from '../BaseSDKShape';
import { PlatformSDKShape } from '../PlatformSDKShape';

export class ContextActionsSDKShape extends BaseSDKShape {
  /**
   * Resolves the context actions a provider declared on its manifest into
   * ready-to-run commands. Each command carries
   * `{ actionName, displayName, description?, execute }` — the
   * `providerIdentifier` is baked into `execute` at resolution time, so the
   * caller supplies only what is runtime-known
   * (`openItem`/`editItem` require `{ sourceItemId }`).
   */
  async getContextActions(
    options: GetContextActionsOptions,
  ): Promise<ContextActionCommand[]> {
    const privateAPI = await this.getPlatformPrivateAPI();

    return privateAPI.contextActions.getContextActions(
      options.providerIdentifier,
      options.actionNames,
    );
  }
}

export default new PlatformSDKShape(ContextActionsSDKShape)
  .withPublicMethod('getContextActions')
  .build();
